export const Usuarios = () => {
    return (
        <div>
            <h1>Seccion usuarios</h1>
        </div>
    )
}
